import { createThemePreset } from "projects/shared/src/lib/style/configuration/theme-color.facrory";
import { AtrThemeColors } from "./atr-theme.colors";

export const AtrPreset = createThemePreset(AtrThemeColors);